import React, { useState } from 'react'
import cx from 'classnames'
import Route from 'route-parser'
import Collapse from '@material-ui/core/Collapse'
import url from 'front-end-core/core/url'
import { URL_LOGOUT, URL_IDP_LOGIN, URL_DOC_DRAFTER_SAVED_DOCUMENTS } from 'constants/urls'
import { UTILS } from 'constants/controllers'
import { isActive } from 'helpers/links'
import preLogout from 'helpers/preLogout'
import NavItem from './NavItem'
import Icon from 'components/shared/Icon'

const SavedDocsRoute = new Route(URL_DOC_DRAFTER_SAVED_DOCUMENTS)

const MenuItem = ({ item, isLogged, flavour, pageId, className, aol, controller }) => {
  const showItem = (
    !item.disabled &&
    (!item.requiresLogged || isLogged)
  )

  const active =
    item.type === 'link' &&
    item.target &&
    (controller === item.target || isActive({ href: url(item.target, { flavour, aol, ...item.params }), pageId }))

  return showItem
    ? (
      <NavItem
        linkClassName={cx('tl db pv5 no-underline outline-0 focus-outline-0 bb b--lite-grey', className, {
          'light-sea-green-2': active,
          black: !active
        })}
        {...item}
      />
      )
    : null
}

export const CollapsibleList = ({ title, items, ...props }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div>
      <div className='flex items-center ph6 pv5 bb pointer' onClick={() => setExpanded(!expanded)}>
        <span className='grow-1'>{title}</span>
        <Icon name={`icon-chevron-${expanded ? 'up' : 'down'}`} className='w7 h7' />
      </div>
      <Collapse in={expanded} timeout='auto'>
        <ul className='list-reset pa0 transition-all'>
          {items.map((item, index) => <MenuItem key={index} {...{ item, ...props }} />)}
        </ul>
      </Collapse>
    </div>
  )
}

const MobileMenu = ({ aol, items, account, isDocDrafter, isLogged, isExternalAuth, ...props }) => {
  const isDev = process.env.NODE_ENV === 'development'

  return (
    <div className='z5 w-100 grow-1 flex flex-column fw6'>
      <ul className='grow-1 list-reset pa0 ma0'>
        {items.map((item, index) => item.type === 'group'
          ? <CollapsibleList key={index} {...{ aol, title: item.title, items: item.items, className: 'ph8', isLogged, ...props }} />
          : <MenuItem key={index} {...{ aol, className: 'ph6', item, isLogged, ...props }} />
        )}
      </ul>
      <ul className='list-reset pa0 ma0 mt7'>
        {isDev && (
          <MenuItem {...{ aol, item: { type: 'link', title: 'Developer Utils', target: UTILS }, className: 'ph6 bt', isLogged, ...props }} />
        )}
        {isLogged && (
          <MenuItem {...{ aol, item: account, className: cx('ph6', { bt: !isDev }), isLogged, ...props }} />
        )}
        {/* saved docs is only corp atm */}
        {isDocDrafter && aol === 'corporate' && (
          <li>
            <a
              href={SavedDocsRoute.reverse({ aol })}
              tabIndex='-1'
              className='tl db ph6 pv5 no-underline outline-0 focus-outline-0 bb b--lite-grey black'
              target='_blank'
              rel='noopener noreferrer'
            >
              Saved Documents
            </a>
          </li>
        )}
        {!isExternalAuth && (
          <li>
            <a
              className='tl db ph6 pv5 no-underline indian-red'
              href={isLogged ? URL_LOGOUT : URL_IDP_LOGIN}
              onClick={preLogout}
              tabIndex='-1'
            >
              {isLogged ? 'Log out' : 'Log in'}
            </a>
          </li>
        )}
      </ul>
    </div>
  )
}

export default MobileMenu
